import { BpFile } from 'components/Files/hooks/useFiles';
import { FileList } from './FileList';

type FileListUploaderProps = {
  files: BpFile[];
  padding?: 'none' | 'default';
  onFilesDelete: (fileUuid: string[]) => void;
  onFileRename: (file: BpFile) => void;
  onFileUpload: (file: BpFile) => void;
  className?: string | undefined;
};

/* wrapper component for file lists where you can only upload */
export const FileListUploader = ({
  files,
  padding,
  onFilesDelete,
  onFileRename,
  onFileUpload,
  className,
}: FileListUploaderProps) => {
  return (
    <FileList
      actions={['delete']}
      files={files}
      padding={padding}
      showHeader
      showSelect
      canUpload
      onFilesDelete={(uuids) => onFilesDelete(uuids)}
      onFileRename={(file) => onFileRename(file)}
      onFileUpload={(file) => onFileUpload(file)}
      className={className}
    />
  );
};
